import {AfterContentInit, Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {Subject} from 'rxjs';
import {DatosSeccionWizardEventsService} from '../../../../services/datos-seccion-wizard-events.service';
import {WizardEventsService} from '../../../../services/wizard-events.service';

import {ButtonControlService} from '../../../../services/button-control.service';
import {takeUntil} from 'rxjs/operators';
import {EvkSeccionModel} from '../../../../../expediente/models/evk-seccion.model';
import {WIZARD_DATA} from '../../../../tokens/tokens';

@Component({
    selector: 'lib-terminos-condiciones',
    templateUrl: './terminos-condiciones.component.html',
    styleUrls: ['./terminos-condiciones.component.css']
})
export class TerminosCondicionesComponent implements OnInit, OnDestroy {

    @Input()
    config: PasoWizard;

    @Input()
    form: FormGroup = new FormGroup({});

    doneForm: Subject<boolean> = new Subject<boolean>();

    readOnly: any;
    paso: PasoWizard;
    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(WIZARD_DATA) public data: any,
        private buttonControlService: ButtonControlService,
        public datosSeccionWizard: DatosSeccionWizardEventsService,
        private wizardEventsService: WizardEventsService
    ) {
        this._unsubscribeAll = new Subject();
        this.readOnly = data.readOnly;
        this.paso = data.paso;
    }

    ngAfterViewInit() {
        this.validarInformacion();
    }

    ngOnInit(): void {

        this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
            this.buttonControlService.cambiarBotonSiguiente(this.form.valid);
            if (this.form.valid) {
                this.onSelectionChanged(value);
            }
        });

    }

    onSelectionChanged(data, save?: boolean) {
        const response: EvkSeccionModel = {
            origen: this.config.nombre,
            propiedades: data
        }
        if (save) {
            this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                this.wizardEventsService.save();
            })
        }
        this.datosSeccionWizard.doneSave(response);
    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    onDoneForm(value: boolean) {
        this.doneForm.next(value);
    }

    validarInformacion() {
        this.doneForm.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            setTimeout(() => {
                this.form.patchValue(this.paso.inData);
                if (this.readOnly) {
                    this.form.disable();
                }
            });
        });
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }

}
